/* eslint-disable react/no-array-index-key, consistent-return, camelcase, import/no-unresolved */
import React from 'react';
import Image from 'next/image';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import CourseItemCourseComponent from '../../components/CourseDashboard/CourseItem/CourseItemResource';
import RestrictedContentComponent from '../../components/RestrictedContent';
import MenuComponent from '../../components/Menu';
import NotFoundContainer from '../NotFound';
import FreeQuizCard from './FreeQuizCard';

import { javaApi } from '../../utils/AxiosInstance';

import DownArrow from '../../assets/images/course-dashboard/DownArrow.gif';

import styles from './FreeQuiz.module.scss';

function FreeQuizContainer() {
  const [freeQuizCard, setfreeQuizCard] = React.useState([]);
  const ref = React.useRef();
  const [totalPages, setTotalPages] = React.useState(1);
  const divRef = React.useRef(null);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const [page, setPage] = React.useState(1);
  const [loading, setLoading] = React.useState(true);
  const [isDownArrow, setisDownArrow] = React.useState(false);
  const [isDivScroll, setIsDivScroll] = React.useState(false);
  const currentPageSize = 20;

  const getCardData = async () => {
    const response = await javaApi.get(
      `app-content-ws/api/v1/feed/content?feedType=QUIZ&page=${page}&pageSize=${currentPageSize}`,
    );
    const data = await response?.data?.data;
    if (data?.length > 0) {
      const quizIdArray = data?.map((item) => item?.quizId);
      const totalNoPages = response?.data?.total_page;
      setTotalPages(Math.round(totalNoPages));

      const payload = { courseId: 0, testIds: quizIdArray, purchased: 1 };

      const testSeriesResponse = await javaApi.post('app-test-series-ws/api/v1/test-series/tests', payload);

      const testStatusArray = await data?.map(({ quizId }) => {
        const matchingObject = testSeriesResponse?.data?.data.find((item) => item?.id === quizId);
        return matchingObject ? matchingObject?.testStatus : null;
      });

      const modifiedData = data.map((item, index) => ({
        ...item,
        testStatus: isAuthenticated ? testStatusArray?.[index] : item?.quizStatus,
        numberOfQuestions: item?.noOfQuestion,
        duration: item?.quizDuration,
        testId: item?.quizId,
        mappingId: item?.quizId,
        contentType: 'TEST_SERIES',
      }));
      if (page === 1) {
        setfreeQuizCard(modifiedData);
      } else {
        setfreeQuizCard((prev) => [...prev, ...modifiedData]);
      }
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      if (page <= totalPages) {
        getCardData();
      } else {
        setLoading(false);
      }
    } else {
      setPage(1);
      setfreeQuizCard([]);
    }
  }, [page, isAuthenticated]);

  const handleInfiniteScroll = async () => {
    try {
      const divElement = document.getElementById('freeQuizWrapper');
      if (divElement.scrollTop + divElement.clientHeight + 1 >= divElement.scrollHeight) {
        setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      // empty
    }
  };

  React.useEffect(() => {
    const divElement = document.getElementById('freeQuizWrapper');
    if (typeof window !== 'undefined') {
      if (divElement) {
        divElement.addEventListener('scroll', handleInfiniteScroll);
        return () => {
          divElement.removeEventListener('scroll', handleInfiniteScroll);
          setfreeQuizCard([]);
        };
      }
    }
  }, [isAuthenticated]);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const downArrowDiv = divRef?.current;
      const handleScroll = () => {
        setIsDivScroll(true);
      };
      if (downArrowDiv) {
        setisDownArrow(downArrowDiv?.scrollHeight > downArrowDiv?.clientHeight);
        downArrowDiv?.addEventListener('scroll', handleScroll);
      }
      return () => {
        downArrowDiv?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [divRef?.current]);

  if (!isAuthenticated) return <RestrictedContentComponent />;

  return (
    <div className={styles.wrapper}>
      <aside ref={ref} className={classNames(styles.sidebar)}>
        <MenuComponent />
      </aside>
      <div className={styles.moduleWrapper}>
        <div className={styles.headerContainer}>
          <div className={styles.titleWrapper}>
            <span className={styles.purchaseTitle} />
          </div>
        </div>
        {!loading && freeQuizCard?.length === 0 && (
          <NotFoundContainer title="Stay tuned, We are curating Daily Quizzes for you!" />
        )}
        <div className={styles.cards} id="freeQuizWrapper" ref={divRef}>
          {isDownArrow && !isDivScroll && freeQuizCard?.length >= 9 && (
          <div
            className={styles.arrowWrapper}
          >
            <div className={styles.innerArrowContainer}>
              <Image
                unoptimized
                src={DownArrow}
                alt="DownArrow"
              />
            </div>
          </div>
          )}
          {freeQuizCard?.length > 0 && <FreeQuizCard data={freeQuizCard} />}
          {loading && [...Array(20)]?.map((item, index) => <CourseItemCourseComponent key={index} skeleton={2} />)}
        </div>
      </div>
    </div>
  );
}

export default FreeQuizContainer;
